import React,{useEffect} from 'react'
import { Link } from 'react-router-dom'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
const Facilities = () => {
     useEffect(() => {
        document.title = 'Facilities -  Mary Matha Cmi  Academy';   
    }, []); 
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
        <li><Link to="/"> Home</Link> </li> 
        <li>  School </li> 
        <li>Facilities </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>Facilities  </h1>
         </div>
     </div>
     <div className="row">
       <div className="col-lg-12">
           <h6>Transportation</h6>
          <p>  Our school transport is not just about getting your child from school to home and vice versa, It is about the comforting reassurance that your child is in safe hands on the way to school and back home. We have fully equipped, well maintained school buses with efficient drivers and bus attendants in all buses to help the students.</p>
       </div>
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default Facilities
